module.exports = __webpack_public_path__ + "static/media/logo.b62d2483.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 169
// module chunks = 0